<template>
  <ValidationObserver
    v-slot="{ invalid, dirty, untouched}"
  >
    <v-row class="cardNorm">
      <v-col
        v-for="({ label, color }, i) in normsAvailable"
        :key="i"
        class="normCell"
      >
        <VTextField
          v-model="normValues[label]"
          :label="label"
          :color="color"
          :extraClass="`${label} norms hide-label`"
          :hint="$t(`sites.norms.${label}`)"
          :rules="{decimal: 8, sNorms: smallerThanNorms(label), bNorms: biggerThanNorms(label)}"
          :disabled="disabled"
          :readonly="readonly"
          dense
          formatNumber
          persistentHint
          veeValidateInteractionMode="eager"
          :data-cy="`test-${label}-${i}-${analysisName}`"
          @focus="$emit('focus')"
        />
      </v-col>
    </v-row>
    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="invalid"
      @change="$emit('validChanged', !invalid)"
    />
    <SlotScopeWatcher
      :value="untouched"
      @change="$emit('untouchChanged', untouched)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        SlotScopeWatcher,
        ValidationObserver,
        VTextField,
    },
    props: {
        normValues: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        analysisName: {
            type: String,
            default: ' ',
        },

    },
    computed: {
        normKeys() {
            return Object.keys(this.normValues);
        },
        normsAvailable() {
            return [
                {
                    label: 'veryLow',
                    color: '#AD1C3F',
                },
                {
                    label: 'low',
                    color: '#D1A918',
                },
                {
                    label: 'minimum',
                    color: '#2A750F',
                },
                {
                    label: 'maximum',
                    color: '#2A750F',
                },
                {
                    label: 'high',
                    color: '#D1A918',
                },
                {
                    label: 'veryHigh',
                    color: '#AD1C3F',
                },
            ];
        },
    },
    methods: {
        smallerThanNorms(normKey) {
            const normIndex = this.normKeys.findIndex(key => key === normKey);
            const normKeysBefore = this.normKeys.slice(0, normIndex);

            return normKeysBefore.map(key => parseFloat(this.normValues[key]));
        },
        biggerThanNorms(normKey) {
            const normIndex = this.normKeys.findIndex(key => key === normKey);
            const normKeysAfter = this.normKeys.slice(normIndex + 1);

            return normKeysAfter.map(key => parseFloat(this.normValues[key]));
        },
    },
};
</script>

<style scoped lang="scss">
.normCell {
    padding: 0;
    margin: 0 5px;
}

.cardNorm {
    background-color: #f5f9fa;
    align-items: center;
    height: 58px;
    width: 100%;
    margin: 0;
    padding: 0 1rem .3rem;

    ::v-deep .v-text-field {
        margin-top: 0;
    }
}
</style>
